<template>
  <div class="good_template1">
    <ul class="clear" v-if="goodsList.length">
      <li v-for="goods in goodsList" :key="goods.goodsId">
        <div @click="toGoodDetail(goods.goodsId,goods.shopIds)">
          <div class="good_image">
              <van-image lazy-load v-if="goods.picUrl" :src="`${goods.picUrl}?imageView2/1/w/330/h/330`" alt=""></van-image>
              <van-image lazy-load v-else src="https://filesouthcdn.nxin.com/nxsc_150277595667202204185653403551.png?imageMogr2/auto-orient/thumbnail/1200000@" alt=""></van-image>
          </div>
        </div>
        <div class="good_main">
          <p class="good_name ellipsis_two">
            <span class="good_tag b_red" v-if="goods.isSelfOperated && goods.isSelfOperated === 1">自营</span>
            <span class="good_tag b_blue" v-if="goods.isOptimization && goods.isOptimization === 1">优选</span>
            <template v-if="goods.goodsTagList && goods.goodsTagList.length">
              <span class="h20 relative good_vip mar5_r" v-for="tag in goods.goodsTagList">{{tag}}</span>
            </template>
            <span>{{goods.name}}</span>
          </p>
          <p class="good_label">
            <span class="good_coupon_icon good_label_item" v-if="goods.coupRegularResList && goods.coupRegularResList.length > 0">
              券<van-icon name="arrow" size="10"/>
              <span class="good_coupon_list">
                <span v-for="coupRegularRes in goods.coupRegularResList" :key="coupRegularRes.regCode">{{coupRegularRes.regDesc}}</span>
              </span>
            </span>
            <span class="good_label_item" v-if="goods.promotionTypeCN && goods.isVip == 0">{{goods.promotionTypeCN}}</span>
            <span class="good_label_item" v-if="goods.isOthersGoodsReceipt && goods.isOthersGoodsReceipt === 1">贺卡</span>
            <span class="good_label_item" v-if="goods.isPrescription === 1">处方药</span>
          </p>
          <p class="good_price_wrap" v-if="goods.sellFactPrice">
            <span class="good_price float-left">
              <template>
                <img class="h15 mar5-r" v-if="goods.goodsPriceMemberLevel === '1'" src="https://filesouthcdn.nxin.com/nxsc_1673594227817048312274484025897.png" />
                <img class="h15 mar5-r" v-else-if="goods.goodsPriceMemberLevel === '2'" src="https://filesouthcdn.nxin.com/nxsc_1673594103328010438901425013813.png" />
                <img class="h15 mar5-r" v-else-if="goods.goodsPriceMemberLevel === '3'" src="https://filesouthcdn.nxin.com/nxsc_167359420355106278603546708517.png" />
                <img class="h15 mar5-r" v-else-if="goods.goodsPriceMemberLevel === '4'" src="https://filesouthcdn.nxin.com/nxsc_1673594183138006841962992133843.png" />
              </template>
              <span class="f10_rem">¥<em class="f14_rem">{{goods.sellFactPrice}}</em></span>
              <!-- <img class="good_vip_icon" v-if="goods.isVip === 1" src="../images/good_vip_icon.png" alt=""> -->
            </span>
            <img v-if="goods.promotionTypeCN !== '集采'" class="good_cart_icon float-right" src="../images/good_cart_icon.png" alt="" @click="joinShoppingCart(goods)">
          </p>
          <p class="good_price_wrap" v-else>
            <span class="good_enquiry">点击询价</span>
          </p>
          <p class="good_oldPrice" v-if="goods.sellPrice && goods.sellPrice != goods.sellFactPrice">¥{{goods.sellPrice}}</p>
        </div>
      </li>
    </ul>
    <div class="good_empty" v-else>
      <img src="../images/noGood.png" alt="">
      <p class="gray_6">暂无货品</p>
    </div>
  </div>
</template>

<script>

import { Toast } from "vant";
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {

  props: {
    goodsList: Array,
    loading: Boolean
  },
  /*
  goodsList[{
  goodsId,  商品id
  picUrl, 商品图片
  isSelfOperated, 是否自营
  isOptimization, 是否优选
  name, 商品名称
  sellFactPrice,  真实售价
  sellPrice,  划线价
  isVip 是否vip
  coupRegularResList:[{regDesc,regCode}]  优惠券集合
  promotionTypeCN 促销类型 中文
  isOthersGoodsReceipt  是否贺卡
  isPrescription  是否处方药
  shopName  店铺名称
  shopIdStr 店铺id 字符串类型 Long型会丢失精度
  }]
  */
  data() {
    return {
    };
  },
  created() {
    const { shopId } = this.$route.query;
    if (common.isInWeiXin()) {
      const ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == "micromessenger"){//eslint-disable-line
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            // 小程序
            if (shopId === "6340867391440003296" || shopId === "6999867391440009601" || shopId === "6340867391440008896") {
              this.isMiniProgram = true;
            } else {
              this.isMiniProgram = false;
            }
          } else {
            this.isMiniProgram = false;
          }
        });
      }
    } else {
      this.isMiniProgram = false;
    }

    console.log("goodsList", this.goodsList);
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  methods: {
    toGoodDetail(goodsId, shopIds) {
      if (this.isMiniProgram) {
        // eslint-disable-next-line
        wx.miniProgram.navigateTo({ url:`/pages/goodsDetail/goodsDetail?id=${goodsId}` });
      } else {
        this.$router.push(`/goodDetails/${goodsId}?fromShopId=${shopIds}`);
      }
      // `/mob/goods/detail/`+ goods.goodsId +`?fromShopId=`+ goods.shopIds
    },
    // 加入购物车
    joinShoppingCart(goods) {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      const params = {
        goodsId: goods.goodsId,
        goodsQuantity: 1,
        fromShopId: goods.shopIds
      };
      this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then((data) => {
        if (data.success === true) {
          Toast("添加成功");
          this.$emit("getCountCart");
        } else if (data.errorcode === -2) {
          window.location.href = `${process.env.VUE_APP_APP}mob/goods/isShowDisplayPrice.do?goodsId=${goods.goodsId}&url=/mob/shop/shopDetail/${goods.shopIds}`;
        } else {
          Toast(data.errormsg);
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
